import React, { createContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

import config from "../../src/config/index";

import axios from "axios";

import agreementdata from "../data/Agreementdata";

import LoadingWidget from "../components/LoadingWidget";

export const AgreementContext = createContext();

export const AgreementProvider = (props) => {
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const { id } = useParams();

  const token = localStorage.getItem("token");

  useEffect(() => {
    setIsLoading(true);
    if (id) {
      axios
        .get(`${config.backendHost}agreements/${id}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          return response.data;
        })
        .then((res) => {
          console.log("Customer1:", res);
          setIsLoading(false);
        
          setData(res);
        })
        .catch(() => {
          console.log("Customer2:", agreementdata);
          setIsLoading(false);
          setData(agreementdata);
        });
    } else {
      console.log("Customer3:", agreementdata);
      setIsLoading(false);
      setData(prev => prev === undefined ? agreementdata : prev);
    }
  }, [id, token]);

  return (
    <>
      {!isLoading ? (
        <AgreementContext.Provider value={[data, setData]}>
          {props.children}
        </AgreementContext.Provider>
      ) : (
        <LoadingWidget />
      )}
    </>
  );
};
